export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Администрирование: Список системных уведомлений",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
